import { useMutation, useQueryClient } from "react-query";
import { AxiosError, AxiosInstance } from "axios";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";

interface CreateRiskTemplateForGroupInput {
  blueprint_name: string;
  blueprint_description: string;
}

interface CreateRiskTemplateForGroupResult {
  crn: string;
}

const createRiskTemplate = async (
  client: AxiosInstance,
  payload: CreateRiskTemplateForGroupInput
): Promise<CreateRiskTemplateForGroupResult> => {
  try {
    const { data } = await client.post("/risk-templates", {
      payload: { ...payload, mitigations: [{}] },
    });
    return data;
  } catch (error) {
    throw new Error((error as AxiosError).response?.data as string);
  }
};

export const useCreateRiskTemplateForGroup = () => {
  const client = useClient();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { displayNotification } = useContext(ControlContext);

  return useMutation(
    async (payload: CreateRiskTemplateForGroupInput) =>
      await createRiskTemplate(client, payload),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["riskTemplates"]);
      },
      onError: (e) => {
        displayNotification!(
          t("riskTemplate.groupings.error_create_hazard"),
          (e as Error).message,
          "error"
        );
      },
    }
  );
};
